import { render } from "./PreloadSpinner.vue?vue&type=template&id=3769be08&scoped=true&ts=true"
import script from "./PreloadSpinner.vue?vue&type=script&lang=ts"
export * from "./PreloadSpinner.vue?vue&type=script&lang=ts"

import "./PreloadSpinner.vue?vue&type=style&index=0&id=3769be08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3769be08"]])

export default __exports__